import { render, staticRenderFns } from "./RejectedOffer.vue?vue&type=template&id=2538f2d6&"
import script from "./RejectedOffer.vue?vue&type=script&lang=js&"
export * from "./RejectedOffer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports